<template>
<!-- 会员管理 -->
<div class="viewContainer">
  <!-- 列表区域 -->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">会员卡管理</p>
    </section>
    <div class="table_container">
      <el-table :data="goodList" stripe border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="Name" label="会员卡名称" align="center">
          <template scope="scope">
            <span :title="scope.row.Name">{{scope.row.Name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Price" label="售价" align="center">
          <template scope="scope">
            <span :title="scope.row.Price">￥{{scope.row.Price}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="UseTimeName" label="有效期" align="center">
          <template scope="scope">
            <span :title="scope.row.UseTimeName">{{scope.row.UseTimeName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="VipCounts" label="会员数" align="center">
          <template scope="scope">
            <span :title="scope.row.VipCounts">{{scope.row.VipCounts}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StatusName" label="在售状态" align="center">
          <template scope="scope">
            <span :title="scope.row.StatusName">{{scope.row.StatusName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template scope="scope">
            <span class="handle" @click="cardStatus(scope)">
              <i :class="scope.row.Status == 1?'el-icon-circle-close':'el-icon-circle-check'"></i>
              {{scope.row.Status == 1?"关闭":"开启"}}
            </span>
            <!-- <span v-if="scope.row.Status != 1" @click="editDetails(scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;">
              <i class="el-icon-edit-outline"></i> 编辑 
            </span> -->
            <span class="handle" @click="editDetails(scope)"> <i class="el-icon-edit-outline"></i> 编辑 </span>
            <span class="handle" @click="seeDetails(scope)"> <i class="el-icon-view"></i> 查看 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>
  
</div>
</template>
<script>
import {getSelectVIPList, UpdateVIPCardStatus} from "../../api/api";
export default {
  name: "MemberList",
  data() {
    return {
      goodList: [], // 查询列表
      pageIndex: 1,
      total: 0,
    };
  },
  methods: {
    // 查询列表
    getlist() {
      var obj = {
        userId: localStorage.Id,
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      getSelectVIPList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.goodList = data.ResultObj;
          this.total = data.RowsCount
        }else{
          this.goodList = []
          this.total = 0
        }
      });
    },
    // 编辑
    editDetails(scope) {
      this.$router.push({
       path:"/MemberDetails",
       query:{
         type:1,
         id:scope.row.Id
       }
     })
    },
    // 查看
    seeDetails(scope) {
      this.$router.push({
       path:"/MemberDetails",
       query:{
         type:2,
         id:scope.row.Id
       }
     })
    },
    // 开启、关闭
    cardStatus(scope) {
      const cardId = scope.row.Id;
      this.$swal({
        type: "warning",
        text: scope.row.Status == 1 ? "是否执行关闭操作" : "是否执行开启操作",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          var obj = {
            userId: localStorage.Id,
            id: cardId
          }
          UpdateVIPCardStatus(obj).then(data => {
            if (data.ResultCode == 1) {
              this.getlist()
              this.$swal({
                type: "success",
                text: "操作成功"
              })
            }
          })
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getlist();
    }
  },
  mounted() {
    this.getlist();
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// MemberList.vue?665910b7